import { renderMarkdown } from '../utils/sanitizer.js';
import { ProductCard } from './ProductCard.jsx';

function ListBlock({ data }) {
  const items = data?.items || [];
  if (!items.length) return null;
  return (
    <ul class="mc-sr-list">
      {items.map((item, i) => (
        <li key={i} class="mc-sr-list-item">
          <span class="mc-sr-list-dot" aria-hidden="true" />
          <span dangerouslySetInnerHTML={{ __html: renderMarkdown(String(item)) }} />
        </li>
      ))}
    </ul>
  );
}

function TableCell({ value, isFirst }) {
  const str = String(value ?? '');
  // First column is always a text label — render plain
  if (isFirst) return <td>{str}</td>;
  // Detect N/A variants
  const isNA = /^(n\/?a|—|-)$/i.test(str.trim()) || str.trim() === '';
  if (isNA) return <td><span class="mc-num-na">—</span></td>;
  // Numeric values get a pill
  const isNum = /^\d+(\.\d+)?$/.test(str.trim());
  if (isNum) return <td><span class="mc-num">{str}</span></td>;
  return <td>{str}</td>;
}

function TableBlock({ data }) {
  const headers = data?.headers || [];
  const rows    = data?.rows    || [];
  if (!headers.length) return null;
  return (
    <div class="mc-sr-table-wrap" role="region" aria-label="Data table">
      <table class="mc-sr-table">
        <thead>
          <tr>{headers.map((h, i) => <th key={i}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => <TableCell key={j} value={cell} isFirst={j === 0} />)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function StepsBlock({ data }) {
  const steps = data?.steps || [];
  if (!steps.length) return null;
  return (
    <ol class="mc-sr-steps">
      {steps.map((s, i) => (
        <li key={i} class="mc-sr-step">
          <span class="mc-sr-step-num" aria-hidden="true">{s.number ?? i + 1}</span>
          <div class="mc-sr-step-body">
            {s.title && <strong class="mc-sr-step-title">{s.title}</strong>}
            {s.description && <span class="mc-sr-step-desc">{s.description}</span>}
          </div>
        </li>
      ))}
    </ol>
  );
}

function CardsBlock({ data }) {
  const items = data?.items || [];
  if (!items.length) return null;
  return (
    <div class="mc-sr-cards">
      {items.map((card, i) => <ProductCard key={i} card={card} />)}
    </div>
  );
}

const BLOCK_MAP = {
  list:  ListBlock,
  table: TableBlock,
  steps: StepsBlock,
  cards: CardsBlock,
};

export function StructuredResponse({ structured }) {
  if (!structured) return null;
  const Block = BLOCK_MAP[structured.type];
  return Block ? <Block data={structured.data} /> : null;
}
